import React from 'react';
import { FiCpu, FiChevronDown, FiImage } from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';
import ImageAnalyzer from './ImageAnalyzer';
import { getTruckTypeLabel } from './utils/helpers';

const AIAssistantPanel = ({
  isOpen,
  onToggle,
  aiInput,
  onInputChange,
  aiLoading,
  isAnalyzing,
  onAnalyzeText,
  onImageUpload,
  imagePreview,
  showDetectionFlash,
  onRemoveImage,
  aiSuggestion,
  formatTND,
  detectionData = null
}) => {
  return (
    <div className="bg-gradient-to-br from-gray-800 to-gray-800/50 border border-amber-500/20 rounded-2xl shadow-lg">
      <div className="p-6">
        <div 
          className="flex items-center justify-between cursor-pointer" 
          onClick={onToggle}
        >
          <div className="flex items-center gap-3">
            <FiCpu className="w-6 h-6 text-amber-400" />
            <h2 className="font-semibold text-lg text-white">Assistant Intelligent</h2>
          </div>
          <FiChevronDown 
            className={`w-5 h-5 text-gray-400 transition-transform ${isOpen ? 'rotate-180' : ''}`} 
          />
        </div>
        
        <AnimatePresence>
          {isOpen && (
            <motion.div
              initial={{ height: 0, opacity: 0, marginTop: 0 }}
              animate={{ height: 'auto', opacity: 1, marginTop: '24px' }}
              exit={{ height: 0, opacity: 0, marginTop: 0 }}
              className="overflow-hidden"
            >
              <div className="space-y-4">
                <textarea
                  placeholder="Décrivez votre déménagement : 'Je déménage un appartement T2 du 3ème étage sans ascenseur vers une maison, environ 15km...'"
                  value={aiInput}
                  onChange={(e) => onInputChange(e.target.value)}
                  rows={3}
                  className="w-full bg-gray-700/50 border border-gray-600 rounded-lg p-3 focus:ring-2 focus:ring-amber-500 focus:border-amber-500 transition-colors text-white placeholder-gray-400"
                />
                
                <div className="space-y-4">
                  <div className="flex flex-wrap gap-2">
                    <button 
                      onClick={onAnalyzeText} 
                      disabled={aiLoading || !aiInput.trim()} 
                      className="px-5 py-2.5 bg-amber-600 font-semibold rounded-lg hover:bg-amber-500 disabled:bg-gray-600 disabled:cursor-not-allowed flex items-center gap-2 transition-colors"
                    >
                      {aiLoading ? (
                        <div className="animate-spin h-5 w-5 border-2 border-white/50 border-t-white rounded-full"></div>
                      ) : (
                        <FiCpu className="w-5 h-5" />
                      )}
                      {aiLoading ? "Analyse en cours..." : "Analyser ma demande"}
                    </button>

                    <label className="px-5 py-2.5 bg-blue-600 font-semibold rounded-lg hover:bg-blue-500 cursor-pointer flex items-center gap-2 transition-colors">
                      <input
                        type="file"
                        accept="image/*"
                        className="hidden"
                        onChange={onImageUpload}
                        disabled={isAnalyzing}
                      />
                      {isAnalyzing ? (
                        <div className="animate-spin h-5 w-5 border-2 border-white/50 border-t-white rounded-full"></div>
                      ) : (
                        <FiImage className="w-5 h-5" />
                      )}
                      {isAnalyzing ? "Analyse..." : "Analyser une image"}
                    </label>
                  </div>

                  <ImageAnalyzer
                    imagePreview={imagePreview}
                    isAnalyzing={isAnalyzing}
                    showDetectionFlash={showDetectionFlash}
                    detectionData={detectionData}
                    onRemoveImage={onRemoveImage}
                  />

                  {aiSuggestion && (
                    <motion.div 
                      initial={{opacity: 0, y: 10}}
                      animate={{opacity: 1, y: 0}}
                      className="p-3 bg-gray-700/50 border border-gray-600 rounded-lg text-sm text-gray-300 mt-2"
                    >
                      <div className="font-semibold text-white mb-1">Recommandation :</div>
                      <div>• Type de camion : <strong className="text-amber-400">{getTruckTypeLabel(aiSuggestion.suggestedTruck)}</strong></div>
                      {aiSuggestion.team && <div>• Équipe : {aiSuggestion.team} personnes</div>}
                      {aiSuggestion.hours && <div>• Durée estimée : {aiSuggestion.hours} heures</div>}
                      {aiSuggestion.price && <div>• Coût estimé : <strong className="text-green-400">{formatTND(aiSuggestion.price)}</strong></div>}
                    </motion.div>
                  )}
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default AIAssistantPanel;




